"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _RadioGroup = require("@material-ui/core/RadioGroup");
var _Chip = require("../../Chip");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ChipButton = function ChipButton(props) {
  var className = props.className,
    testId = props.testId,
    checked = props.checked,
    value = props.value,
    onChange = props.onChange,
    icon = props.icon,
    label = props.label;
  var radioGroup = (0, _RadioGroup.useRadioGroup)();
  var isChecked = checked;
  if (radioGroup !== null && radioGroup !== void 0 && radioGroup.value) {
    isChecked = radioGroup.value === value;
  }
  return /*#__PURE__*/_react["default"].createElement(_Chip.Chip, {
    testId: testId,
    className: className,
    selected: isChecked,
    icon: icon,
    onClick: function onClick() {
      var newChecked = !checked;
      var event = {
        target: {
          value: value,
          checked: !checked
        }
      };
      if (radioGroup !== null && radioGroup !== void 0 && radioGroup.onChange) {
        // @ts-ignore
        radioGroup.onChange(event, newChecked);
      } else if (onChange) {
        // @ts-ignore
        onChange(event, newChecked);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, label));
};
exports.ChipButton = ChipButton;